module.exports = __webpack_public_path__ + "a17d279f/img/lock-icon.bb9c7166.svg";